import { IVisitTreatmentPlanObjective } from '~/services/api/clientDetails/types';
import { IOption } from '~/types';

const formatObjectivesOptions = (objectives: IVisitTreatmentPlanObjective[]): IOption[] =>
  objectives.map(item => ({
    label: item.text,
    value: String(item.id),
  }));

export default formatObjectivesOptions;
